import React from 'react';
import './Catalogue.css';
import '../root.css'
import Search from '../components/Common/Search';
import FilterTitle from '../components/Common/FilterTitle';
import TypeBtn from '../components/Common/TypeBtn';
import Apartment from '../Assets/Icons/Apartment.svg';
import Villa from '../Assets/Icons/Villa.svg';
import Cabin from '../Assets/Icons/Cabbin.svg';
import MainBtn from '../components/Common/Btn';
import RangeSlider from '../components/Common/RangeSlider';
import Header from '../components/Layout/header';
import Footer from '../components/Layout/Footer';
import { useState } from 'react';
import PropertyCard2 from '../components/Common/PropertyCard2';
import home1 from '../Assets/Imgs/home1.jpg';
import home2 from '../Assets/Imgs/home2.jpg';
import home3 from '../Assets/Imgs/home3.jpg';
import home4 from '../Assets/Imgs/home4.jpg';
import home5 from '../Assets/Imgs/home5.jpg';
import home6 from '../Assets/Imgs/home6.jpg';
import extra1 from '../Assets/Imgs/extra1.jpg';
import extra2 from '../Assets/Imgs/extra2.jpg';
import extra3 from '../Assets/Imgs/extra3.jpg';




const Catalogue = () => {
    const [filter, setfilter] = useState (false)

    const showFilter = () => {
        setfilter(shown => !shown)
    }


    return ( <>
            <Header />
            <div className="bgGrid"></div>
        <div className='Main'>
            <button onClick={showFilter} className='errorBtn'>Filters</button>
            <aside className={filter ? "AsideHidden" : "" }>
                <div className='Search'>
                    <Search />
                </div>

                <div className='Type'>
                    <FilterTitle FilterTitle="Type"/>

                    <div className='TypeBtns'>
                        <TypeBtn TypeBtnStyle="TypeBtn" TypeBtnImg={Apartment} TypeBtnText="Apartment"/>
                        <TypeBtn TypeBtnStyle="TypeBtn" TypeBtnImg={Villa} TypeBtnText="Villa"/>
                        <TypeBtn TypeBtnStyle="TypeBtn" TypeBtnImg={Cabin} TypeBtnText="Cabin"/>
                    </div>
                </div>

                <div className='Bedrooms'>
                    <FilterTitle FilterTitle="Bedrooms"/>

                    <div className='BedBtns'>
                        <MainBtn btnStyle="BedBtn" btnText="1" />
                        <MainBtn btnStyle="BedBtn" btnText="2" />
                        <MainBtn btnStyle="BedBtn" btnText="3" />
                        <MainBtn btnStyle="BedBtn" btnText="4" />
                        <MainBtn btnStyle="BedBtn" btnText="5" />
                        <MainBtn btnStyle="BedBtn" btnText="6" />
                    </div>
                </div>

                <div className='Area'>
                    <FilterTitle FilterTitle="Area (sqm)"/>

                    <RangeSlider LeftValue="100" RightValue="500"/>
                </div>

                <div className='Price'>
                    <FilterTitle FilterTitle="Price (EGP)"/>

                    <RangeSlider LeftValue="500k" RightValue="4M+"/>
                </div>
            </aside>
            <div className="propertyCol">
                <PropertyCard2 extraImg1={extra1} extraImg2={extra2} extraImg3={extra3} propertyImg={home1} propertyTitle="Maple House" propertyDescription="Elegant House Villas with spacious layouts, gardens, and premium amenities for luxurious living." bedValue="3 Bd" bathValue="3 Bth" areaValue="298 Sqm" />
                <PropertyCard2 extraImg1={extra1} extraImg2={extra2} extraImg3={extra3} propertyImg={home2} propertyTitle="Zee House" propertyDescription="A modern home with open interiors, stylish finishes, and thoughtfully designed spaces for effortless living." bedValue="2 Bd" bathValue="1 Bth" areaValue="286 Sqm" />
                <PropertyCard2 extraImg1={extra1} extraImg2={extra2} extraImg3={extra3} propertyImg={home3} propertyTitle="Twin House" propertyDescription="A pair of contemporary residences offering balanced layouts, shared charm, and private comfort for families or couples." bedValue="4 Bd" bathValue="6 Bth" areaValue="391 Sqm" />
                <PropertyCard2 extraImg1={extra1} extraImg2={extra2} extraImg3={extra3} propertyImg={home4} propertyTitle="Cedar Villa" propertyDescription="A luxury villa featuring warm natural materials, expansive rooms, and serene outdoor areas inspired by nature." bedValue="3 Bd" bathValue="3 Bth" areaValue="355 Sqm" />
                <PropertyCard2 extraImg1={extra1} extraImg2={extra2} extraImg3={extra3} propertyImg={home5} propertyTitle="Oakwood" propertyDescription="A refined residence combining generous living spaces, elegant details, and a peaceful atmosphere for upscale comfort." bedValue="5 Bd" bathValue="4 Bth" areaValue="425 Sqm" />
                <PropertyCard2 extraImg1={extra1} extraImg2={extra2} extraImg3={extra3} propertyImg={home6} propertyTitle="Willow Estate" propertyDescription="A grand estate with sweeping grounds, spacious interiors, and premium amenities designed for a sophisticated lifestyle." bedValue="3 Bd" bathValue="3 Bth" areaValue="298 Sqm" />
            </div>
        </div>
        <Footer />
        </>
     );
}
 
export default Catalogue;